<template>
    <b-modal
        id="modalDotacao"
        v-model="mostrarModalDotacao"
        @show="preencherForm()"
        @hide="$emit('modalFechado')"
    >
        <div slot="modal-title">
            Dotação Orçamentária -
            <b-badge variant="warning">{{ operacao }}</b-badge>
        </div>
        <b-row v-if="tipo == 'I'">
            <b-col sm="12">
                <b-form-group>
                    <label>Unidade</label>
                    <b-form-select
                        :options="unidades"
                        v-model="codUnidade"
                        text-field="nome"
                        value-field="codUnidade"
                        @input="$v.codUnidade.$touch()"
                    ></b-form-select>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row v-if="tipo == 'I'">
            <b-col sm="12">
                <b-form-group>
                    <label>Projeto</label>
                    <b-form-select
                        :options="projetos"
                        v-model="codProjeto"
                        text-field="nome"
                        value-field="codProjeto"
                        @input="$v.codProjeto.$touch()"
                    ></b-form-select>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row v-if="tipo == 'I'">
            <b-col sm="12">
                <b-form-group>
                    <label>Ação</label>
                    <b-form-select
                        :options="acoes"
                        v-model="codAcao"
                        text-field="nome"
                        value-field="codAcao"
                        @input="$v.codAcao.$touch()"
                    ></b-form-select>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12">
                <b-form-group>
                    <label>Saldo Projeto/Ação</label>
                    <money
                        v-model="saldoProjetoAcao"
                        v-bind="money"
                        class="form-control text-right"
                        :disabled="true"
                    ></money>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12">
                <b-form-group>
                    <label>Valor total a ser rateado</label>
                    <money
                        v-model="valorTotal"
                        v-bind="money"
                        class="form-control text-right"
                        :disabled="true"
                    ></money>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12">
                <b-form-group>
                    <label>Valor disponível para rateio</label>
                    <money
                        v-model="valorDisponivelTemp"
                        v-bind="money"
                        class="form-control text-right"
                        :disabled="true"
                    ></money>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12">
                <b-form-group>
                    <label> Rateio Por: </label>
                    <b-form-radio-group v-model="rateioPor">
                        <b-form-radio value="v">
                            <strong>VALOR</strong>
                        </b-form-radio>
                        <b-form-radio value="p">
                            <strong>PERCENTUAL</strong>
                        </b-form-radio>
                    </b-form-radio-group>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12">
                <b-form-group
                    :state="$v.valor.$error ? false : null"
                    invalid-feedback="Valor deve ser maior que 0 e menor ou igual ao valor disponível"
                >
                    <label>Valor</label>
                    <money
                        v-model="valor"
                        v-bind="money"
                        class="form-control text-right"
                        :disabled="rateioPor != 'v'"
                        @input.native="$v.valor.$touch()"
                    ></money>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12">
                <b-form-group
                    :state="$v.valor.$error ? false : null"
                    invalid-feedback="O percentual deve gerar um valor maior que 0 e menor ou igual ao valor disponível"
                >
                    <label>Percentual</label>
                    <money
                        v-model="percentual"
                        v-bind="perc"
                        class="form-control text-right"
                        :disabled="rateioPor != 'p'"
                        @input.native="$v.percentual.$touch()"
                    ></money>
                </b-form-group>
            </b-col>
        </b-row>
        <div slot="modal-footer">
            <b-button variant="secondary" @click.stop="fecharModalDotacao()"
                >Cancelar</b-button
            >
            <b-button
                variant="primary"
                :disabled="$v.$invalid"
                @click.stop="confirmarSalvarDotacao()"
                class="ml-1"
                >Salvar</b-button
            >
        </div>
    </b-modal>
</template>

<script>
import { required, maxValue, minValue } from 'vuelidate/lib/validators'
import DotacoesServicos from './DotacoesServicos'

export default {
    props: {
        rateio: {
            type: Object,
            default: () => ({})
        },

        tipo: {
            type: String,
            default: () => 'I'
        },

        mostrarModal: {
            type: Boolean,
            default: () => false
        },

        valorTotal: {
            type: Number,
            default: () => 0
        },

        valorDisponivel: {
            type: Number,
            default: () => 0
        },

        dataMovimento: {
            type: String
        }
    },

    data() {
        return {
            mostrarModalDotacao: false,
            valorDisponivelTemp: 0,
            codUnidade: null,
            codProjeto: null,
            codAcao: null,
            valor: 0,
            percentual: 0,
            rateioPor: 'v',
            unidades: [],
            projetos: [],
            acoes: [],
            saldoProjetoAcao: 0,
            justificativa: null,
            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                suffix: '',
                precision: 2,
                masked: false
            },
            perc: {
                decimal: ',',
                thousands: '.',
                prefix: '',
                suffix: '%',
                precision: 5,
                masked: false
            },
            rateioPorOpcoes: [
                { value: 'v', text: 'Valor' },
                { value: 'p', text: 'Percentual' }
            ]
            // justificativaApostilamento: ''
        }
    },

    computed: {
        operacao() {
            switch (this.tipo) {
                case 'I':
                    return 'INSERÇÃO'
                case 'A':
                    return 'ATUALIZAÇÃO'
                default:
                    return 'INDEFINIDO'
            }
        }
    },

    methods: {
        obterUnidades() {
            this.$store.dispatch('addRequest')
            DotacoesServicos.obterUnidades().then((response) => {
                if (response) {
                    if (response.success) {
                        this.unidades = response.data
                        if (this.tipo == 'I') {
                            this.codUnidade = this.unidades[0].codUnidade
                        }
                    } else {
                        this.$toast.error(
                            response.errors,
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterProjetos() {
            this.$store.dispatch('addRequest')
            DotacoesServicos.obterProjetos(this.codUnidade).then((response) => {
                if (response) {
                    if (response.success) {
                        this.projetos = response.data
                        if (this.projetos && this.projetos.length > 0) {
                            if (this.tipo == 'I') {
                                this.codProjeto = this.projetos[0].codProjeto
                            }
                        } else {
                            this.codProjeto = null
                            this.acoes = []
                        }
                    } else {
                        this.$toast.error(
                            response.errors,
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterAcoes() {
            this.$store.dispatch('addRequest')
            DotacoesServicos.obterAcoes(this.codUnidade, this.codProjeto).then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.acoes = response.data
                            if (this.acoes && this.acoes.length > 0) {
                                if (this.tipo == 'I') {
                                    this.codAcao = this.acoes[0].codAcao
                                }
                            }
                        } else {
                            this.$toast.error(
                                response.errors,
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        obterSaldoProjetoAcao() {
            let hoje = new Date()
            let ano = hoje.getFullYear()
            let mes = hoje.getMonth()
            if (this.dataMovimento) {
                let dtMovimento = this.$moment(this.dataMovimento, 'DD/MM/YYYY')
                ano = dtMovimento.year()
                mes = dtMovimento.month()
            }
            this.$store.dispatch('addRequest')
            DotacoesServicos.obterSaldoProjetoAcao(
                this.codUnidade,
                this.codProjeto,
                this.codAcao,
                ano,
                mes
            ).then((response) => {
                if (response) {
                    if (response.success) {
                        this.saldoProjetoAcao = response.data
                    } else {
                        this.$toast.error(
                            response.errors[0],
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        fecharModalDotacao() {
            this.resetDotacao()
        },

        resetDotacao() {
            this.mostrarModalDotacao = false
            this.valorDisponivelTemp = 0
            this.erros = []
            this.codUnidade = null
            this.codProjeto = null
            this.codAcao = null
            this.valor = 0
            this.percentual = 0
            this.rateioPor = 'v'
            this.unidades = []
            this.projetos = []
            this.acoes = []
            this.justificativa = null
            this.$nextTick(() => {
                this.$v.$reset()
            })
        },

        preencherForm() {
            if (this.tipo == 'I') {
                this.obterUnidades()
                this.valorDisponivelTemp = this.valorDisponivel
                this.valor = this.valorDisponivelTemp
            }
            if (this.tipo == 'A') {
                this.valor = this.rateio.nuValorRateio
                this.percentual = this.rateio.percentual
                this.valorDisponivelTemp = this.valorDisponivel + this.valor
                this.justificativa = this.rateio.justificativa
            }
        },

        confirmarSalvarDotacao() {
            this.$swal({
                title: 'Dotação Orçamentária',
                html: `Confirma a ${
                    this.tipo == 'I' ? 'inserção' : 'atualização'
                } da dotação orçamentária?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.salvarDotacao()
                }
            })
        },

        salvarDotacao() {
            this.$store.dispatch('addRequest')
            if (this.tipo == 'A') {
                let dotacaoDto = {
                    codUnidade: this.rateio.codUnidade,
                    unidade: this.rateio.unidade,
                    codProjeto: this.rateio.codProjeto,
                    projeto: this.rateio.projeto,
                    codAcao: this.rateio.codAcao,
                    acao: this.rateio.acao,
                    nuValorRateio: this.valor
                }
                this.$emit('atualizarRateio', dotacaoDto)
            } else {
                let dotacaoDto = {
                    codUnidade: this.codUnidade,
                    unidade: this.unidades.filter((u) => {
                        return u.codUnidade == this.codUnidade
                    })[0].nome,
                    codProjeto: this.codProjeto,
                    projeto: this.projetos.filter((u) => {
                        return u.codProjeto == this.codProjeto
                    })[0].nome,
                    codAcao: this.codAcao,
                    acao: this.acoes.filter((u) => {
                        return u.codAcao == this.codAcao
                    })[0].nome,
                    nuValorRateio: this.valor
                    // percentual: this.percentual,
                    // justificativa: this.justificativa
                }
                this.$emit('inserirRateio', dotacaoDto)
            }

            this.registroSalvoComSucesso()
            this.$store.dispatch('removeRequest')
        },

        registroSalvoComSucesso() {
            this.fecharModalDotacao()
        }
    },

    watch: {
        mostrarModal() {
            this.mostrarModalDotacao = this.mostrarModal
        },

        codUnidade(newVal, oldVal) {
            if (newVal !== null) {
                this.obterProjetos()
            }
        },

        codProjeto(newVal, oldVal) {
            if (newVal !== null) {
                this.obterAcoes()
            }
        },

        valor() {
            if (this.rateioPor == 'v') {
                this.percentual = (this.valor / this.valorTotal) * 100
            }
        },

        percentual() {
            if (this.rateioPor == 'p') {
                this.valor = (this.valorTotal * this.percentual) / 100
            }
        },

        codAcao(newVal, oldVal) {
            if (newVal !== null) {
                this.obterSaldoProjetoAcao()
            }
        }
    },

    validations: {
        codUnidade: {
            codUnidadeOk() {
                if (this.tipo == 'I') {
                    return this.codUnidade != null
                }
                return true
            }
        },
        codProjeto: {
            codProjetoOk() {
                if (this.tipo == 'I') {
                    return this.codProjeto != null
                }
                return true
            }
        },
        codAcao: {
            codAcaoOk() {
                if (this.tipo == 'I') {
                    return this.codAcao != null
                }
                return true
            }
        },
        valor: {
            required,
            minValue: minValue(0.01),
            valorOk() {
                return this.valor <= this.valorDisponivelTemp
            }
        },
        percentual: {
            required,
            minValue: minValue(0.00001)
        }
    }
}
</script>
